import type { Event, EventInfo, EventSpeaker, EventTypes, MainEventInfo, Product, mailEventType, questionnaireList } from '~/types/api/client/events/index';
import { EventinfoAPI } from './eventinfo';
export class EventsAPI {

    clientId: number| string;

    constructor(clientId: number | string) {
        this.clientId = clientId;
        //this.eventinfo = new EventinfoAPI(subeventId)
    }

    event(eventId: number){
        return new EventinfoAPI(this.clientId, eventId)
    }

    async getEvents(eventid?: number | string): Promise<MainEventInfo[] | {status: number, message: string}> {
        const response = await $fetch<MainEventInfo[]>(`/api/client/events/events`, {
            headers:useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
                eventid: eventid
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }

    async getMailEventType(): Promise<mailEventType[] | {status: number, message: string}> {
        const response = await $fetch<any[]>(`/api/client/events/mailEventType`, {
            headers:useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }

    async getQuestionnaireList(): Promise<questionnaireList[] | {status: number, message: string}> {
        const response = await $fetch<any[]>(`/api/client/events/questionnaireList`, {
            headers:useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }


    async getProductList(): Promise<Product[] | {status: number, message: string}> {
        const response = await $fetch<Product[]>(`/api/client/events/productList`, {
            headers:useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
        
    }

    async getEventChoices( eventtypeid?: number ): Promise<{productList: Product[], questionnaireList: questionnaireList[], mailEventTypeList: mailEventType[], eventtypesList: EventTypes[]} | {status: number, message: string}> {
  
        const response = await $fetch<{productList: Product[], questionnaireList: questionnaireList[], mailEventTypeList: mailEventType[], eventtypesList: EventTypes[]}>(`/api/client/events/eventChoices`, {
            headers: useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }
    async getEventTypes(eventTypeId?: number): Promise<EventTypes[] | {status: number, message: string}> {
        const response = await $fetch<EventTypes[]>(`/api/client/events/eventtypes`, {
            headers: useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
                eventtypeid: eventTypeId
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }

}